// Don't use `rem` units for anything since existing CSS `font-size` affects all rem units
// https://github.com/am-systems/am-web-properties/blob/c1d44502a5babfe955a7f7462eba23658a73bbe3/public/thecreditreview/css/top-services/media-query.css#L22-L25.
// Existing `rem` units are migrated values from old styles to avoid breaking layouts.
export const getStyles = ({ companyIndex }) => ({
	featuredCompanyHeader: {
		wrapper:
			"tw:bg-[#ebf4ff] tw:text-center tw:text-balance tw:rounded-t-[3px]",
		contentWrapper: "tw:text-black tw:font-bold tw:leading-8 tw:text-[16px]",
	},
	serviceFlag: {
		wrapper: "tw:absolute tw:top-[9px] tw:left-[-5px] tw:flex",
		flag: `tw:w-[24px] tw:h-[24px] tw:bg-[#1d8ce0] tw:shadow-[1px_3px_3px_lightgrey] tw:flex tw:items-center tw:justify-center tw:rounded-[3px] tw:xs2:w-[28px] tw:xs2:h-[28px] tw:xs2:p-0 tw:border tw:border-solid  tw:border-[#1d8ce0]`,
		number:
			"tw:text-white tw:text-[12px] tw:font-avenirNextDemi tw:m-0 tw:pt-[2px] tw:xs2:text-[14px] tw:leading-[1.4286]",
		text: "tw:relative tw:ml-1 tw:h-[24px] tw:text-white tw:py-2 tw:pl-3 tw:flex tw:items-center tw:justify-center tw:bg-[#1d8ce0] tw:text-[12px] tw:font-semibold tw:leading-[15px] tw:shadow-[1px_3px_3px_lightgrey] tw:xs2:h-[28px] tw:xs2:text-[13px] tw:after:relative tw:after:left-[6px] tw:after:w-[22px] tw:after:inset-0 tw:after:[border-right:13px_solid_white] tw:after:[border-top:12px_solid_#1e8ce0] tw:after:[border-bottom:12px_solid_#1e8ce0] tw:xs2:after:[border-right:15px_solid_white] tw:xs2:after:[border-top:14px_solid_#1e8ce0] tw:xs2:after:[border-bottom:14px_solid_#1e8ce0]",
	},
	companyLogo: {
		picture: "tw:max-w-[300px] tw:text-center",
		image: "tw:max-w-[70%] tw:desktop:max-w-[160px]",
	},
	trustpilotReview: {
		container:
			"tw:flex tw:flex-col tw:w-fit tw:text-center tw:min-w-[118px] tw:max-w-[120px] tw:desktop:mt-[20px]",
		reviewCount:
			"tw:text-[#232227] tw:font-semibold tw:text-[13px] tw:leading-[1.4286] tw:xs2:text-[14px]",
		reviewCountNumber: "tw:font-bold tw:font-graphikWeb",
		reviewCountText: "tw:font-normal",
		ratingContainer: "tw:my-[4px] tw:flex tw:gap-[3px] tw:justify-center",
		starBase:
			"tw:relative tw:rounded-[3px] tw:w-[18px] tw:h-[18px] tw:flex tw:items-center tw:justify-center tw:text-white tw:text-[12px] tw:xs2:text-[14px] tw:xs2:w-[21px] tw:xs2:h-[21px]",
		ratingCountWrapper: "tw:w-full tw:flex tw:items-end tw:justify-evenly",
		ratingCount:
			"tw:font-bold tw:text-[14px] tw:text-[#232227] tw:leading-none",
		ratingCountText: "tw:text-[14px] tw:text-[#232227] tw:leading-none",
		trustPilotLogo: "tw:h-[16px] tw:w-auto",
	},
	columnInformation: {
		wrapper: "tw:grid tw:w-full tw:items-center",
		columnWrapper:
			"tw:flex tw:flex-col tw:pb-5 tw:justify-center tw:text-center tw:desktop:flex-row tw:px-[5px] tw:desktop:py-0",
		column: "",
		label:
			"tw:pb-[5px] tw:font-montserrat tw:text-[11px] tw:text-[#787e81] tw:uppercase tw:font-semibold tw:tracking-wider tw:xs2:tracking-[0.08em] tw:desktop:hidden tw:leading-[1.4286]",
		value:
			"tw:text-[13px] tw:leading-[1.4286] tw:font-semibold tw:text-[#232227] tw:xs2:text-[16px]",
	},
	benefitsList: {
		wrapper: "",
		list: `${companyIndex === 0 ? "tw:mb-[5px] tw:mt-0" : "tw:m-0"} tw:flex tw:flex-col tw:desktop:max-w-[305px] tw:desktop:mb-0`,
		listItem: `tw:mb-[6px] tw:pl-[25px] tw:text-[#48484b] tw:text-[14px] tw:font-semibold tw:leading-[1.4286] tw:bg-[url(/public/react-images/common/iconTick.svg)] tw:bg-no-repeat tw:bg-position-[left_top_5px] ${companyIndex === 0 ? "tw:last:mb-0" : ""}`,
		expandButton:
			"tw:mt-[5px] tw:w-full tw:flex tw:cursor-pointer tw:items-center tw:border-0 tw:bg-transparent tw:py-0 tw:pl-[25px] tw:text-[#48484b] tw:md:mt-5",
		expandBenefitsContent: "tw:text-[13px]",
		expandButtonIcon: "tw:ml-[4px] tw:text-[18px] tw:rotate-90",
	},
	reviewLink: {
		wrapper:
			"tw:text-center tw:text-[#1d8ce0] tw:text-[14px] tw:font-semibold tw:leading-[1.4286] tw:desktop:mx-auto tw:[border-bottom:1px_dashed] tw:mt-[10px]",
		text: "",
	},
});
